import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import LogoSection from '../LogoSection/LogoSection.js'
import SearchSection from '../SearchSection/SearchSection.js'
import ProfileSection from '../ProfileSection/ProfileSection.js'
import NavOptionButton from '../NavOptionButton/NavOptionButton.js'
import LoginButton from '../LoginButton/LoginButton.js'
import AuthForm from '../AuthForm/AuthForm.js'
import Overlay from '../Overlay/Overlay.js'
import NavPane from '../NavPane/NavPane.js'
import { supabase } from '../../supabaseClient'

const NavBar = () => {
  const showAuth = useSelector(state => state.user.showAuth)
  const [notifications, setNotifications] = useState([])
  const isLogged = useSelector(state => state.user.isLoggedIn)
  const currentUser = useSelector(state => state.user.userInfo)

  // Drawer state inside NavBar
  const [navPaneVisible, setNavPaneVisible] = useState(false)

  const fetchNotifications = async () => {
    if (!currentUser?.id) return

    try {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('user_id', currentUser.id)
        .eq('read', false)
        .order('created_at', { ascending: false })

      if (error) throw error

      setNotifications(data || [])
    } catch (error) {
      console.error('Error fetching notifications:', error.message)
    }
  }

  useEffect(() => {
    if (isLogged) {
      fetchNotifications()
    }
  }, [isLogged, currentUser])

  return (
    <div className="w-full flex-none sticky top-0 left-0 right-0 z-50">
      {showAuth && (
        <div>
          <Overlay z="z-40" />
          <AuthForm />
        </div>
      )}

      {/* TOP HEADER BAR */}
      <div 
        className="flex relative w-full h-14 md:h-16 items-center rounded-md border-b border-black px-3 md:px-6 text-white z-50 gap-3 md:gap-6 overflow-visible"
        style={{
          background: 'linear-gradient(to bottom, #bebebe 0, #777 3%, #232323 55%, #1d1d1d 55%, teal 330%, #000 100%)',
          boxShadow: `
            0px 6px 18px rgba(0, 0, 0, 0.75),
            inset 0px 1px 0px rgba(255, 255, 255, 0.25),
            inset 0px -1px 0px rgba(0, 0, 0, 0.8)
          `
        }}
      >
        {/* Left Side: Hamburger & Logo */}
        <div className="flex items-center space-x-2 md:space-x-3 text-white shrink-0">
          <NavOptionButton setNavPaneVisible={setNavPaneVisible} />
          <LogoSection />
        </div>
        
      
  {/* Hide search on small screens; show on medium screens and up */}
<div className="hidden md:flex ml-auto flex-1 max-w-xl md:max-w-2xl min-w-0">
  <SearchSection />
</div>


        <div className="flex items-center space-x-2 md:space-x-3 text-[#cccc] shrink-0">
          {isLogged && (
            <ProfileSection notifications={notifications} setNotifications={setNotifications} />
          )}
          <LoginButton />
        </div>
      </div>

      {/* TRANSPARENT CLICK-AWAY OVERLAY */}
      {navPaneVisible && (
        <div 
          className="fixed inset-0 z-30 bg-black/40 backdrop-blur-[1px] transition-opacity"
          onClick={() => setNavPaneVisible(false)}
        />
      )}

      {/* SMOOTH UNROLLING / CROPPING DROPDOWN CONTAINER */}
      <div 
        className={`absolute top-14 md:top-16 left-0 z-40 rounded-b-lg shadow-2xl border-b border-r border-black/80 grid transition-all duration-300 ease-in-out ${
          navPaneVisible 
            ? 'grid-rows-[1fr] opacity-100 pointer-events-auto shadow-[0_12px_24px_rgba(0,0,0,0.7)]' 
            : 'grid-rows-[0fr] opacity-0 pointer-events-none border-none'
        }`}
      >
        <div className="overflow-hidden [&::-webkit-scrollbar]:hidden [scrollbar-width:none] rounded-b-lg">
          <NavPane />
        </div>
      </div>
    </div>
  )
}

export default NavBar
